import { Chip } from "@mui/material";
import { FunctionField, useTranslate } from "react-admin";

export const renderStatus = (record: any) => {
    const t = useTranslate();
    const status = record?.status;

    if (status == null) {
        return <Chip />;
    }

    return <Chip label={t("resources.common.choices.contentStatus." + status)} />;
};

export const ContentStatusField = ({ label, source }: { label: string; source: string }) => {
    return <FunctionField source={source} label={label} render={renderStatus} />;
};
